export const COL_SPAN = {
  ID: 1,
  NAME: 10,
  ACTIONS: 1,
}
